import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const nps = {
  state: {
    total: 0,
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: {
    async get(payload, rootState) {
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      const url = `${DomainAPI}${Channel}/api/secure/npsServices/get`;

      return await fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async getDataForChart(payload, rootState) {
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      const url = `${DomainAPI}${Channel}/api/secure/npsServices/getDataForChart`;

      return await fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async getDataForList(payload, rootState) {
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      const url = `${DomainAPI}${Channel}/api/secure/npsServices/getDataForList`;

      return await fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          this.setState({ total: res.data.total });
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
  },
};

export default nps;
